import React, { FC, memo, ReactElement } from "react";
import { useDispatch } from "react-redux";
import { ListItem, Typography } from "@material-ui/core";

import { DeleteIcon } from "../../../icons";
import TweetComponentActionsModal from "../TweetComponentActionsModal/TweetComponentActionsModal";
import { deleteTweetReply } from "../../../store/ducks/tweet/actionCreators";
import { fetchDeleteTweet } from "../../../store/ducks/tweets/actionCreators";
import { setOpenSnackBar } from "../../../store/ducks/actionSnackbar/actionCreators";
import { useModalWindow } from "../../../hook/useModalWindow";
import { HOME } from '../../../constants/path-constants';
import { useHistory } from 'react-router-dom';

interface DeleteTweetButtonProps {
    tweetId: string;
    addressedTweetId?: string;
    onCloseActionsDropdown: () => void;
}

const DeleteTweetButton: FC<DeleteTweetButtonProps> = memo((
    {
        tweetId,
        addressedTweetId,
        onCloseActionsDropdown
    }
): ReactElement => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { visibleModalWindow, onOpenModalWindow, onCloseModalWindow } = useModalWindow();

    const onDeleteUserTweet = (): void => {
        if (addressedTweetId) {
            dispatch(deleteTweetReply(tweetId));
        } else {
            dispatch(fetchDeleteTweet(tweetId));
        }
        dispatch(setOpenSnackBar({
            message: "Your Tweet was deleted"
        }));
        onCloseModalWindow();
        onCloseActionsDropdown();

        // Redirecting to Home
        const path = window.location.pathname;
        if (tweetId && path.includes(tweetId.toString())) {
          history.push(HOME);
        }
    };

    return (
        <>
            <ListItem id={"delete"} onClick={onOpenModalWindow}>
                <>{DeleteIcon}</>
                <Typography variant={"body1"} component={"span"}>
                    Delete
                </Typography>
            </ListItem>
            <TweetComponentActionsModal
                modalTitle={"Delete"}
                visibleTweetComponentActionsModal={visibleModalWindow}
                onCloseTweetComponentActionsModal={onCloseModalWindow}
                onClick={onDeleteUserTweet}
            />
        </>
    );
});

export default DeleteTweetButton;
